import React from "react";
import { useTranslation } from "react-i18next";

function PrivacyPolicy() {
  const { t } = useTranslation();

  const sections = [
    {
      title: t("privacyPolicy.scope.title"),
      content: [
        { type: "text", value: t("privacyPolicy.scope.text1") },
        { type: "text", value: t("privacyPolicy.scope.text2") },
      ],
    },
    {
      title: t("privacyPolicy.accessData.title"),
      content: [
        { type: "text", value: t("privacyPolicy.accessData.text1") },
        {
          type: "list",
          items: t("privacyPolicy.accessData.list", { returnObjects: true }),
        },
        { type: "text", value: t("privacyPolicy.accessData.text2") },
      ],
    },
    {
      title: t("privacyPolicy.cookies.title"),
      content: [
        { type: "text", value: t("privacyPolicy.cookies.text1") },
        { type: "text", value: t("privacyPolicy.cookies.text2") },
      ],
    },
    {
      title: t("privacyPolicy.personalData.title"),
      content: [
        { type: "text", value: t("privacyPolicy.personalData.text1") },
        { type: "text", value: t("privacyPolicy.personalData.text2") },
      ],
    },
    {
      title: t("privacyPolicy.contactData.title"),
      content: [{ type: "text", value: t("privacyPolicy.contactData.text") }],
    },
    {
      title: t("privacyPolicy.userRights.title"),
      content: [{ type: "text", value: t("privacyPolicy.userRights.text") }],
    },
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" id="privacy-policy">
      {/* Header Section */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold tracking-tight text-slate-900 dark:text-slate-100">
          {t("privacyPolicy.title")}
        </h1>
      </div>

      {/* Sections */}
      <div className="space-y-6">
        {sections.map((section, index) => (
          <div
            key={index}
            className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm p-6"
          >
            <h2 className="text-xl font-semibold text-slate-900 dark:text-slate-100 mb-4 pb-2 border-b border-slate-200 dark:border-slate-700">
              {section.title}
            </h2>
            <div className="space-y-4">
              {section.content.map((item, itemIndex) => {
                if (item.type === "text") {
                  return (
                    <p
                      key={itemIndex}
                      className="text-slate-600 dark:text-slate-400 leading-relaxed"
                    >
                      {item.value}
                    </p>
                  );
                }
                if (item.type === "list") {
                  return (
                    <ul
                      key={itemIndex}
                      className="list-disc list-inside space-y-2 text-slate-600 dark:text-slate-400 ml-4"
                    >
                      {item.items.map((listItem, listIndex) => (
                        <li key={listIndex} className="leading-relaxed">
                          {listItem}
                        </li>
                      ))}
                    </ul>
                  );
                }
                return null;
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PrivacyPolicy;
